import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ElementOrIcon } from '../../elementOrIcon/elementOrIcon';
// styles
import { InputIconContainerStyled } from '../input.styled';
const InputIconStandAloneComponent = (props, ref) => {
    const icon = props.leftIcon || props.rightIcon;
    if (!icon || props.loading) {
        return null;
    }
    const hasAction = !!props.rightIcon?.onClick || !!props.leftIcon?.onClick;
    const onClick = event => {
        props.rightIcon?.onClick?.(event);
        props.leftIcon?.onClick?.(event);
    };
    return (_jsx(InputIconContainerStyled, { ref: ref, "$pointerEvents": hasAction, inputIconContainerStyles: props.rightIcon ? props.styles?.inputIconContainerRight : props.styles?.inputIconContainer, styles: props.styles, children: _jsx(ElementOrIcon, { customIconStyles: props.styles?.inputIcon, disabled: props.disabled, ...props.rightIcon, ...props.leftIcon, onClick: hasAction ? onClick : undefined }) }));
};
export const InputIconStandAlone = React.forwardRef(InputIconStandAloneComponent);
//# sourceMappingURL=inputIcon.js.map